import { createSafeContext } from "app/presentation/utils/createSafeContext";

export const [BreakpointsContext, useBreakpointsContext] = createSafeContext(
    "useBreakpointsContext must be used within BreakpointsContext"
);
